import overdueApplicationInboxes from "./overdueApplicationInboxes";

const overdueApplicationInboxService = [
    {
        matcher: 'overdueApplicationInboxes',
        reply: config => {
            return [200, overdueApplicationInboxes];
        }
    },
    {
        matcher: /overdueApplicationInboxes\/(.*)/,
        reply: config => {
            const id = /overdueApplicationInboxes\/(.*)/.exec(config.url)[1];
            const data = overdueApplicationInboxes.find(item => item.uuid === id);
            return [200, data];
        }
    },
]

export default overdueApplicationInboxService;